/**
 * @generated SignedSource<<c385651e18a3890ccae3d0dae7441327>>
 * @relayHash 47b6bed432e93d293b71d554de9d22cf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8e6818c1b5edb7793a16ffa9f89aef19e1986ebf11c163e4b84b6c6c60cf8d8d

import type { ConcreteRequest, Query } from 'relay-runtime';
export type EntryPointContentQuery$variables = {
  cloudId: string;
};
export type EntryPointContentQuery$data = {
  readonly jira: {
    readonly permission: {
      readonly hasPermission: boolean | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type EntryPointContentQuery = {
  response: EntryPointContentQuery$data;
  variables: EntryPointContentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "concreteType": "JiraQuery",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          },
          {
            "kind": "Literal",
            "name": "type",
            "value": "BULK_CHANGE"
          }
        ],
        "concreteType": "JiraPermission",
        "kind": "LinkedField",
        "name": "permission",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "hasPermission"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "EntryPointContentQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EntryPointContentQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "8e6818c1b5edb7793a16ffa9f89aef19e1986ebf11c163e4b84b6c6c60cf8d8d",
    "metadata": {},
    "name": "EntryPointContentQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "815386dc8abe733af632d767353933e2";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
